import { RadioGroup, RadioGroupProps } from '@chakra-ui/react'

export type { RadioGroupProps }
export default RadioGroup
